/// <reference path="../../../global.d.ts" />
import { Tooltip } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Collapse from "@material-ui/core/Collapse";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Toolbar from "@material-ui/core/Toolbar";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { checkActivityFunctions, navigateToUrl } from "single-spa";
import "./Menu.css";
import { isExpireToken, logout, menu, useStyles } from "./Menu.logic";

import {
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import AccountMenuMicrofrontend from "../AccountMenu";
import NotificationMicrofrontend from "../Notification";

const Menu = (props: any): JSX.Element => {
  const classes = useStyles();
  const [modules, setModules] = useState<any[]>([]);
  const [open, setOpen] = useState(true);
  const [stateModules, setStateModules] = useState<any>([]);
  const [expireToken, setExpireToken] = useState(true);

  const generateClassName = createGenerateClassName({
    seed: "container",
  });

  const click = async () => {
    setExpireToken(await isExpireToken());
    if (expireToken) {
      let data = await menu();
      if (data) {
        setStateModules(data.modules);
        setModules(data.modules);
        localStorage.setItem("scopes", JSON.stringify(data.scopes));
      }
    }
  };

  useEffect(() => {
    click();
    window.addEventListener("single-spa:before-routing-event", () => {
      const currentPath = window.location;
      const activeApps = checkActivityFunctions(currentPath);
      
      const specificActiveApps = activeApps.filter(app => app !== 'notifier');
      
      if (specificActiveApps.length === 0) {
        navigateToUrl("/");
      }
    });
  }, []);

  const handleClick = (id: any) => {
    if (!open) {
      setOpen(true);
    }
    setStateModules(
      stateModules.map((item: any) => {
        if (item.id === id) {
          item.open = !item.open;
          item.isSelected = true;
          return item;
        } else {
          item.isSelected = false;
          item.open = false;
          return item;
        }
      })
    );
  };

  const redirectClick = async (url: string): Promise<any> => {
    setExpireToken(await isExpireToken());
    if (open) {
      setOpen(false);
    }

    setStateModules(
      stateModules.map((item: any) => {
        return { ...item, open: false };
      })
    );
    navigateToUrl(url);
  };

  const handleDrawer = () => {
    if (open) {
      setStateModules(
        stateModules.map((item: any) => {
          return { ...item, open: false };
        })
      );
    }

    setOpen(!open);
  };

  const handlerClickContainer = () => {
    setOpen(false);
  };

  if (window.location.pathname.toLocaleLowerCase() === "/login") {
    return (
      <div>
        <div id="single-spa-application:user-authentication-ui"></div>
      </div>
    );
  }

  if (!localStorage.getItem("token") || !expireToken) {
    logout();
  }
  //
  const SubModule = ({ module }) => {
    const [openSubModule, setOpenSubModule] = useState({});

    const handleToggle = (indexSubModule) => {
      setOpenSubModule((prevState) => ({
        ...prevState,
        [indexSubModule]: !prevState[indexSubModule],
      }));
    };

    return (
      <>
        {module.resources.map((subModule, indexSubModule) => (
          <div key={indexSubModule} className="subModuleDiv">
            <Tooltip title={subModule.tittle}>
              <ListItem
                button
                onClick={() => {
                  subModule.url !== null
                    ? redirectClick(subModule.url)
                    : handleToggle(indexSubModule);
                }}
              >
                <ListItemIcon></ListItemIcon>
                <ListItemText
                  className="textTitleMenu"
                  inset
                  primary={subModule.tittle}
                />
                {subModule.resources && subModule.resources.length > 0 && (
                  <IconButton onClick={handleToggle}>
                    {openSubModule[indexSubModule] ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </IconButton>
                )}
              </ListItem>
            </Tooltip>
            {subModule.resources && subModule.resources.length > 0 && (
              <>
                <Collapse
                  in={openSubModule[indexSubModule]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List
                    id="idListItemSecondaryResource"
                    className="resourcesInsideList"
                    disablePadding
                    key="idListItemSecondaryResource"
                  >
                    <SubModule module={subModule} />
                  </List>
                </Collapse>
              </>
            )}
          </div>
        ))}
      </>
    );
  };

  //

  return (
    <div>
      <CssBaseline />
      <AppBar id="appBarId" position="fixed" className={classes.appBar}>
        <StylesProvider generateClassName={generateClassName}>
          <Toolbar id="idToolbar">

            <IconButton
              id="idIconButton"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawer}
              edge="start"
            >
              <MenuIcon className={classes.menuIcon} />
            </IconButton>
            <div className="logo-wrapper">
              <img
                className={"menu-logo logo-simplex"}
                src={`${process.env.PUBLIC_URL}/logo-simplex-2.svg`}
                alt="Simplex"
              />
              <div className="logo-separator" aria-hidden="true"></div>
              <img
                className={"menu-logo logo-satrack"}
                src="https://stoportaltest.blob.core.windows.net/doggie-ui/assets/logos/satrack-white-plain-logo.svg"
                alt="Satrack"
              />
            </div>

            <div className="user-options">
              <NotificationMicrofrontend />

              <AccountMenuMicrofrontend />
            </div>

          </Toolbar>
        </StylesProvider>
      </AppBar>
      <Drawer
        id="idMenuDrawer"
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar} id="idToolbarDiv"></div>
        <List component="nav" id="idListNav" key="idListNav">
          {modules.map((module, index) => (
            <React.Fragment key={module.id}>
              <Tooltip title={module.tittle} id="idTooltip">
                <ListItem
                  id="idListItem"
                  button
                  onClick={() => handleClick(module.id)}
                  style={{
                    color: stateModules.find(
                      (item: any) => item.id === module.id
                    ).isSelected
                      ? "#4080f8"
                      : "#707071",
                  }}
                >
                  <ListItemIcon
                    id="idListItemIcon"
                    style={{
                      color: stateModules.find(
                        (item: any) => item.id === module.id
                      ).isSelected
                        ? "#4080f8"
                        : "#707071",
                    }}
                  >
                    <i className="material-icons-outlined">{module.icon}</i>
                  </ListItemIcon>
                  <ListItemText
                    id="idListItemText"
                    className="textTittleMenu"
                    inset
                    primary={module.tittle}
                  />
                  {stateModules.find((item: any) => item.id === module.id)
                    .open ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </ListItem>
              </Tooltip>
              <Collapse
                in={
                  stateModules.find((item: any) => item.id === module.id).open
                }
                timeout="auto"
                unmountOnExit
              >
                <List
                  id="idListItemSecundary"
                  component="div"
                  disablePadding
                  key="idListItemSecundary"
                >
                  <SubModule module={module} />
                </List>
              </Collapse>
            </React.Fragment>
          ))}
        </List>
      </Drawer>

      <main className="content" id="container" onClick={handlerClickContainer}>
        <div>
          <div id="single-spa-application:activation-manager-webui"></div>
          <div id="single-spa-application:clients-manager-webui"></div>
          <div id="single-spa-application:devices-manager-webui"></div>
          <div id="single-spa-application:customer-manager-webui"></div>
          <div id="single-spa-application:alarm-notification-reporter-webui"></div>
          <div id="single-spa-application:yielde-manager-webui"></div>
          <div id="single-spa-application:yielde-reporter-webui"></div>
          <div id="single-spa-application:notifier"></div>
          <div id="single-spa-application:platform-user-searcher-webui"></div>
          <div id="single-spa-application:monitoring-custom-follow-register-webui"></div>
          <div id="single-spa-application:monitoring-custom-follow-reporter-webui"></div>
          <div id="single-spa-application:fuel-dipstick-report-webui"></div>
          <div id="single-spa-application:monitoring-custom-follow-attender-webui"></div>
          <div id="single-spa-application:simplex-platform-menu-webui"></div>
          <div id="single-spa-application:devices-massive-creator-webui"></div>
          <div id="single-spa-application:businessname-autosuspension-excluded-webui"></div>
          <div id="single-spa-application:vehicle-preactivatedeleter-webui"></div>
          <div id="single-spa-application:businessname-suspendreporter-webui"></div>
          <div id="single-spa-application:alarm-customer-configuration-manager-webui"></div>
          <div id="single-spa-application:massives-deactivate-schedule-webui"></div>
          <div id="single-spa-application:load-retention-manager-webui"></div>
          <div id="single-spa-application:vehicle-deactivateschedulemanager-webui"></div>
          <div id="single-spa-application:devices-serial-migration-manager-webui"></div>
          <div id="single-spa-application:vehicle-schedule-status-change-webui"></div>
          <div id="single-spa-application:load-plates-scheduled-deactivation-webui"></div>
          <div id="single-spa-application:businessname-down-payment-ui"></div>
          <div id="single-spa-application:accounting-dian-efacture-webui"></div>
          <div id="single-spa-application:ado-plan-pricechange-webui"></div>
          <div id="single-spa-application:accounting-dian-create-credit-note-webui"></div>
          <div id="single-spa-application:devices-alteredfrequencyreport-webui"></div>
          <div id="single-spa-application:businessname-checknameintegrator-webui"></div>
          <div id="single-spa-application:consumption-report-ui"></div>
        </div>
      </main>
    </div>
  );
};

export default Menu;
